<template>
  <div :class="{ bg_pad: bgPad === 'bg0' }" class="clearfix order_product">
    <img :src="item.skuPic" alt="" class="left product_img_order" />
    <div :class="{ border_bottom1px: pageShow }" class="left right_item">
      <div class="name_mr ">
        <div
          class="name_name font12 font_weight400 colo0 font_line_2 text_left line_height_17"
        >
          {{ item.skuName }}
        </div>
        <div class="font10 font_weight400 colo055 name_spec text_left">
          规格：{{ item.skuSpec }}
        </div>
        <div class="sku_tags">
          <tags :tradeType="item.tradeType" :includeTax="item.includeTax" />
        </div>
      </div>
      <div class="font14 font_weight600 colo087 line_height_16">
        <div class="product_price">
          {{ item.skuNowPrice | currency(false) }}
        </div>
        <!-- <div class="price_num font12 font_weight400 colo087 line_height_14">
          ×1
        </div> -->
        <van-stepper
          input-width="38px"
          button-size="15px"
          :default-value="item.skuAmount"
          :max="item.skuAmount"
          @change="changeNum"
        />
        <!-- <div v-if="false" class="font12 font_weight400 refund_status">
          订单受理中
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
const Tags = () => import("@/components/Tags").then(m => m.default || m);
export default {
  props: {
    index: {
      type: Number,
      default: 1
    },
    index1: {
      type: Number,
      default: 1
    },
    listIndex: {
      type: Number,
      default: 0
    },
    pageShow: {
      type: Boolean,
      default: false
    },
    bgPad: {
      type: String,
      default: ""
    },
    item: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  components: {
    Tags
  },
  data() {
    return {
      value: ""
    };
  },
  methods: {
    changeNum(num) {
      this.$emit("changeNum", num, this.index, this.index1);
    }
  }
};
</script>
<style lang="less" scoped>
.order_product {
  // margin: 0 12px;
  // padding-right: 12px;
  .product_img_order {
    width: 96px;
    max-height: 96px;
  }
  .right_item {
    width: 70%;
    display: flex;
    justify-content: space-between;
  }
  .name_mr {
    margin: 12px 0 0 12px;
    .name_name {
      width: 120px;
    }
    .name_spec {
      max-width: 120px;
      margin-top: 4px;
    }
    .sku_tags {
      margin-top: 6px;
    }
  }
  .product_price {
    margin: 29px 0 22px;
  }
  .price_num {
    margin-top: 8px;
  }
  .refund_status {
    color: #d91818;
    margin-top: 12px;
  }
}
.bg_pad {
  padding-right: 0 !important;
}
</style>
